import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, of } from "rxjs";
import { GlobalDataService } from "src/app/core/services/faker/global-data.service";
import { SchoolActions } from "./school.actions";

@Injectable()
export class SchoolEffects {
    constructor(
        private actions$: Actions,
        private globalDataService: GlobalDataService
    ) { }

    loadSchools$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SchoolActions.loadSchools),
            mergeMap(() => {
                const data = this.globalDataService.getSchools();
                if (data && data.length > 0) {
                    return of(data).pipe(
                        map(schools => SchoolActions.loadSchoolsSuccess({ schools })),
                        catchError(error => of(SchoolActions.loadSchoolsFailure({ error })))
                    );
                } else {
                    return of(SchoolActions.loadSchoolsFailure({ error: 'Guardian data not found' }));
                }
            })
        )
    );
}